var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    className: "hover:stroke-cyan-500 transition-all",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 6.72501L10.4417 2.55834C10.1975 2.31417 9.80167 2.31417 9.55833 2.55834L5.39167 6.72501C5.14667 6.96917 5.14667 7.36501 5.39167 7.60834C5.63667 7.85167 6.03083 7.85334 6.275 7.60834L9.375 4.50834V13C9.375 13.345 9.655 13.625 10 13.625C10.345 13.625 10.625 13.345 10.625 13V4.50834L13.725 7.60834C13.8467 7.73084 14.0067 7.79167 14.1667 7.79167C14.3267 7.79167 14.4867 7.73167 14.6083 7.60834C14.8525 7.36417 14.8525 6.96917 14.6083 6.72501Z",
    fill: "#8899A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4233 18.7867H3.57666C2.52332 18.7867 1.66666 17.93 1.66666 16.8767V12.1667C1.66666 11.8217 1.94666 11.5417 2.29166 11.5417C2.63666 11.5417 2.91666 11.8217 2.91666 12.1667V16.8767C2.91666 17.2409 3.21249 17.5367 3.57666 17.5367H16.4233C16.7875 17.5367 17.0833 17.2409 17.0833 16.8767V12.1667C17.0833 11.8217 17.3633 11.5417 17.7083 11.5417C18.0533 11.5417 18.3333 11.8217 18.3333 12.1667V16.8767C18.3333 17.93 17.4767 18.7867 16.4233 18.7867Z",
    fill: "#8899A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6d8644ffc0283c3907939cb39e845c4f.svg";
export { ForwardRef as ReactComponent };